import { AgentGuide } from "@/components/agents/agent-guide";
import { createFileRoute } from "@tanstack/react-router";

/** `/agents/$slug/manual` — the in-app manual: what the agent can do
 *  and how to use each capability. */
export const Route = createFileRoute("/_app/agents/$slug/manual")({
  component: AgentManual,
});

function AgentManual() {
  const { slug } = Route.useParams();
  return <AgentGuide slug={slug} />;
}
